<template>
  <v-container>
    <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir Canal
        </v-btn>
      </v-col>
    </v-row>

    <!-- show-expand
        single-expand -->
    <br />

    <v-data-table
      :search="search"
      :headers="headers"
      :items="channelList"
      item-key="id"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100],
      }"
    >
      <!-- <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template> -->

      <template v-slot:[`item.action`]="{ item }">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleEdit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'error' : 'blue-grey'"
            @click.stop="handleDelete(item)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-hover>
      </template>
    </v-data-table>

    <newForm
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="eventToEdit"
      @close:dialog="closeFormDialog"
    ></newForm>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import newForm from "./newForm.vue";
// import btnupdate from '@/components/auth/user/btnupdate.vue';

export default {
  components: {
    newForm,
    // btnupdate,
  },

  data: () => ({
    isLoading: false,
    isOpenForm: false,
    isEditMode: false,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    channelList: [],
    eventToEdit: {},
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "left",
        value: "name",
        class: "primary--text",
        width: "35%",
      },
      {
        text: "Troncal",
        align: "left",
        value: "troncal.name",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Cantidad",
        value: "quantity",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Fecha",
        value: "date",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getChannelTrunks();
      },
      deep: true,
    },
  },

  created() {
    this.getChannelTrunks();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.eventToEdit = item;
      this.openFormDialog();
    },

    async handleDelete(event) {
      // const accessToken = localStorage.getItem("token");

      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este evento? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          PbxHttpClient.delete(`/clients/channel_troncal/${event.id}`)
            .then((res) => {
              const index = this.channelList.findIndex(
                (el) => el.id === res.data.Troncal
              );
              this.channelList.splice(index, 1);

              this.$snotify.success("Troncal eliminado", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error("Hubo un error al eliminar.", "Error");
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar el troncal.", "¡Error!");
        // console.error(error);
      }
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode)
        this.channelList = this.channelList.map((el) =>
          el.id === data.id ? data : el
        );
      if (data && !this.isEditMode)
        this.channelList = [data, ...this.channelList];

      // console.log(this.channelList);
      this.isOpenForm = false;
      this.isEditMode = false;
      this.eventToEdit = {};
    },

    async getChannelTrunks() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/clients/channel_troncal`, {
        params: { page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.channelList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
